

<template>
  <section class="relative z-0 bg-cover bg-center text-white text-center pt-44 pb-60 px-4">
    <h1 class="text-3xl md:text-5xl font-extrabold mb-4">ICP - INTEGRATOR CONTROL PANEL</h1>
    <p class="text-lg md:text-xl mb-8">
      Publique seus aplicativos em VPS com simplicidade com o nosso painel ICP
    </p>
  </section>
</template>
